import { SOULMATE_REPORT_MODAL_V1_PLAN_ID } from "@/features/subscriptions/report-plan-codes"
import { ReportIds } from "@/features/today/config/reports-data"

import type { AppModalComponentProps } from "../config/modal-registry"
import { ReportPromoModalV1, type ReportPromoCopyV1 } from "./report-promo-modal-v1"

const COPY: ReportPromoCopyV1 = {
  reportId: ReportIds.Soulmate,
  planId: SOULMATE_REPORT_MODAL_V1_PLAN_ID,
  title: "Unlock Your Soulmate Sketch",
  description: "See a personalized sketch of the face the stars may be guiding toward your path",
}

export function ReportSoulmateSketchModalV1(props: AppModalComponentProps) {
  return <ReportPromoModalV1 {...props} copy={COPY} />
}
